//$Id$
/**
 * @file ajax-util
 * @version 1.0.0
 * @notes Kinldy avoid usage of changeRestAPIUrlForCrmPlus, getZPCSRF, getZPCSRFName, getZPCSRFValue with your own ajax method - Use ajaxRequest
 * Deprecated Functions: fixForCachingInIe, ajaxShowTab, ajaxSendRequest, ajaxSaveOrder, ajaxComplete, ajaxShowPage, ajaxConstructPage, ajaxSubmitPage, ajaxSendFormRequest, ajaxUtils, Query.ajax, commonFunctions.beforeSend - Use ajaxRequest
 */

/**
 * To make ajax request on server
 * @param {object} ajaxObject Eg: {'url': '/tasks/<task_id>', type: 'post'}
 */
 async function ajaxRequest(ajaxObject) {
	
	try{
		var options = {}, response = {};
		var defaultObject = {
				type: _GET,
				args: undefined,
				url: undefined,
				restAPI: true,
				dataType: 'json',//no i18n
				contentType : undefined,
				processData : undefined,
				async: true,
				apiVersion : undefined,
				actionButton: undefined,
				beforeSend: undefined,
				complete: undefined
		};
		ajaxObject = Object.assign(defaultObject, ajaxObject);
		
		options.method=ajaxObject.type.toUpperCase();
		options.contentType = ajaxObject.contentType;
		options.restAPI = ajaxObject.restAPI;
		options.apiVersion = ajaxObject.apiVersion;
		options.args = ajaxObject.args;
		options.accept = ajaxObject.dataType;
		options.processData = ajaxObject.processData;
		options.signal = ajaxObject.signal;
		
		if(Object.prototype.toString.call(options.args) === '[object Array]' && options.args.length &&  options.args[0]['name'] != undefined && options.args[0]['value'] != undefined){
			options.args = options.args.reduce((obj, keyValue) => {
				let value = keyValue.value;
				if(obj[keyValue.name]){
					value = Array.isArray(obj[keyValue.name]) ? [...obj[keyValue.name], keyValue.value] : [obj[keyValue.name], keyValue.value];
				}
				obj[keyValue.name] = value;
				return obj
			}, {});
		}
		
		beforeSend(ajaxObject);
		
		response = await RequestHandler.fetch(ajaxObject.url, options);
		
		complete(ajaxObject);
	
		 return response;
	}catch(error){
		complete(ajaxObject);
		if(error.status == ZPResponse.STATUS.TOO_MANY_REQUESTS){
           UI.Utils.showError({message:getI18nValue('zp.security.throttlelimitexceed')}); //No I18N
         }
		console.log(error);
		throw error;
	}
	
	function beforeSend(ajaxObject){
		
		if (ajaxObject.beforeSend) {
    		ajaxObject.beforeSend(ajaxObject);
    	}
		if (ajaxObject.actionButton) {
			jQuery(ajaxObject.actionButton).attr("zps-loader", "yes") //NO I18N
										   .attr("disabled", "disabled") //NO I18N
		}
	}
	
	function complete(ajaxObject){
		if (ajaxObject.actionButton) {
			jQuery(ajaxObject.actionButton).attr("zps-loader", "") //NO I18N
										   .removeAttr("disabled", "disabled") //NO I18N
		}
	}
	
	/*return new Promise((resolve, reject) => {
		ajaxObject.method=ajaxObject.type;
		if(Object.prototype.toString.call(ajaxObject.args) === '[object Array]'){
			ajaxObject.args = ajaxObject.args.reduce((obj, keyValue) => {obj[keyValue.name] = keyValue.value; return obj}, {});
		}
			
		RequestHandler.fetch(ajaxObject.url, ajaxObject).then(response => {
			resolve({data: response});
		})
	});*/
	
}

/**
 * Change Request URL for crmplus
 * @param {object} settings URLto be modified Eg: {url: '/tasks/<task_id>'}
 */
function changeRestAPIUrlForCrmPlus(settings){
	if((typeof IsWPloaded == "undefined" || !IsWPloaded) && (typeof crmpluslibcheck != "undefined" && crmpluslibcheck)){
		(settings.url.indexOf('/restapi/portal') == 0 || settings.url.indexOf('/api/v3') == 0) ? (settings.url = "/portal"+settings.url) : 0;//no i18n
	}
}

/**
 * Get CSRF token
 * @returns CSRF token with key zpcp Eg: zpcp=asd123asdfer
 */
function getZPCSRF()
{
	var mvar_csrf =  getZPCSRFName() + "=" + getZPCSRFValue();//No I18N
	return mvar_csrf; 
}
/**
 * Get CSRF token key
 * @returns CSRF token key
 */
function getZPCSRFName()
{
	return "zpcp";//No I18N 
}
/**
 * Get CSRF token value
 * @returns CSRF token value
 */
function getZPCSRFValue()
{
	return getCookie("zpct");//No I18N 
}

Object.assign(window, {ajaxRequest, changeRestAPIUrlForCrmPlus, getZPCSRF, getZPCSRFName,getZPCSRFValue});